import { ChannelDataOrder, IDateTimeAudienceCountry, IUser, IUserPreferenceDataRequest } from "./types";
import { Post as Desconecta } from "../services/SessionService";
import { UpdatePreferences } from "../services/UserService";

export function setUserPreferenceLocalStorage(userPreference: any, auth: any) {

    let userLocalStorageOld = getUserPreferenceLocalStorage();
    let userLocalStorage: IUser = {}
    if (userPreference && auth) {
        userLocalStorage = SaveLocalStorage(userPreference, userLocalStorageOld, auth);
    }

    localStorage.setItem('userPreference', JSON.stringify(userLocalStorage));
}

function SaveLocalStorage(userPreference: any, userLocalStorageOld: any, auth: any) {    
    const SelectedTypeGrid = localStorage.getItem('selectTypeGrid');
    const selectTypeGridValue = SelectedTypeGrid ? parseInt(SelectedTypeGrid) : 0;

    let userLocalStorage = {
        languageID: userPreference.Language.Id,
        baseID: userPreference.TipoBase,
        autoUpdate: userPreference.UserAutoScroll,
        archivedReport: {
            date: userPreference.Data.split('T')[0],
            start: userPreference.HorarioIni.split('T')[1],
            end: userPreference.Horario.split('T')[1]
        },
        mergedRows: {
            frequencyID: userPreference.Periodicidade.Id,
            mergeFunctionID: parseInt(userPreference.Ordenacao)
        },
        customerName: userPreference.Customer ? userPreference.Customer.Name : userLocalStorageOld?.Customer?.Name,
        Customer: userPreference.Customer ?? userLocalStorageOld?.Customer,
        groupID: userPreference.Praca.Id,
        groupShortLabel: userPreference.Praca.Abrev,
        groupLabel: userPreference.Praca.Desc,

        classID: userPreference.Praca?.Targets?.some(target => target.Id === userPreference.Target.Id)
            ? userPreference.Target.Id
            : userPreference?.Praca?.Targets[0]?.Id,

        classLabel: userPreference.Praca?.Targets?.some(target => target.Id === userPreference.Target.Id)
            ? userPreference.Target.Desc
            : userPreference?.Praca?.Targets[0]?.Desc,

        subgroupID: userPreference.PracaImagem ? userPreference.PracaImagem.Id : null,
        variableComboID: userPreference.Indice,
        tosURL: userPreference.Country?.CountryParameters?.find(current => current.Dsc === 'URL_TERMO')?.Val ?? null,
        helpURL: userPreference.Country?.CountryParameters?.find(current => current.Dsc === 'URL_MANUAL')?.Val ?? null,
        token: auth.token,
        username: auth.username,
        rememberLogin: auth.rememberLogin,
        tosAgree: auth.tosAgree,
        countryID: userPreference.Country.CountryID,
        selectTypeGrid: selectTypeGridValue
    }
    return userLocalStorage;
}

export async function VerificaTargetUpdate(userPreference: any) {
    const payloadRequest: IUserPreferenceDataRequest = {
        userPreference: userPreference,
    };
    if (ValidAccessTokenLocalStorage()) {
        UpdatePreferences(getAccessTokenLocalStorage(), payloadRequest)
            .catch((err) => {
            });
    }
}

function changeLanguage(lang: string | null, i18n, setErrorLogin) {
    let langChangeTo = lang?.toUpperCase();
    switch (langChangeTo) {
      case "es".toUpperCase():
      case "es-es".toUpperCase():
        i18n.changeLanguage("es-ES").catch((err) => {
          if (setErrorLogin) setErrorLogin(err.toString());
        });
        break;
      case "en".toUpperCase():
      case "en-US".toUpperCase():
        i18n.changeLanguage("en-US").catch((err) => {
          if (setErrorLogin) setErrorLogin(err.toString());
        });
        break;
      case "pt".toUpperCase():
      case "pt-BR".toUpperCase():
        i18n.changeLanguage("pt-BR").catch((err) => {
          if (setErrorLogin) setErrorLogin(err.toString());
        });
        break;
    }
  }


export function getUserPreferenceLocalStorage() {
    const json = localStorage.getItem('userPreference');
    if (!json) return null;
    const user: IUser = JSON.parse(json);
    return user;
}

export function cleanUserPreferenceLocalStorage() {
    return new Promise<void>((resolve) => {
        localStorage.removeItem('userPreference');
        resolve();
    })
}

export function getUserNameLocalStorage() {
    const json = localStorage.getItem('userPreference');
    if (!json) return null;
    const userLS = JSON.parse(json);
    return userLS.username;
}

export function setAccessTokenLocalStorage(token: string) {
    localStorage.setItem('sessionToken', token);
}

export function getAccessTokenLocalStorage() {
    const token = localStorage.getItem('sessionToken');
    if (!token) return null;
    return token;
}

export function cleanTokenLocalStorage() {
    return new Promise<void>((resolve) => {
        localStorage.removeItem('sessionToken');
        resolve();
    });
}

export function setUserAuthLocalStorage(userAuth: IUser) {
    if (userAuth.rememberLogin === true) {
        localStorage.setItem('UserAuth', JSON.stringify(userAuth));
        sessionStorage.removeItem('UserAuth');
    } else {
        sessionStorage.setItem('UserAuth', JSON.stringify(userAuth));
        localStorage.removeItem('UserAuth');
    }
}

export function getUserAuthLocalStorage(): IUser | null {

    const resultStorage = localStorage.getItem('UserAuth');
    let user: any;
    if (resultStorage !== null) {
        user = JSON.parse(resultStorage);
    }
    const resultSession = sessionStorage.getItem('UserAuth');
    if (resultSession !== null) {
        user = JSON.parse(resultSession);
    }
    return user;
}
export function cleanUserAuthLocalStorage() {
    const resultStorage = localStorage.getItem('UserAuth');

    if (resultStorage !== null) {
        localStorage.removeItem('UserAuth');
    }
    const resultSession = sessionStorage.getItem('UserAuth');
    if (resultSession !== null) {
        sessionStorage.removeItem('UserAuth');
    }
}
export function setIntervalAutoUpdateLocalStorage(value: string) {
    localStorage.setItem('intervalAutoUpdate', value);
}
export function getIntervalAutoUpdateLocalStorage() {
    const result = localStorage.getItem('intervalAutoUpdate');
    if (!result) return null;
    return result;
}
export function setSettingsImage(value: string) {
    localStorage.setItem('settingsImage', value);
}
export function getSettingsImage() {
    const result = localStorage.getItem('settingsImage');
    if (!result) return null;
    return result;
}
export function cleanIntervalAutoUpdateLocalStorage() {
    localStorage.removeItem('intervalAutoUpdate');
}
export function setlsDescFullStorage(value: string) {
    localStorage.setItem('lsDescFull', value);
}
export function getlsDescFullStorage() {
    const result = localStorage.getItem('lsDescFull');
    if (!result) return null;
    return result;
}
export function cleanlsDescFullStorage() {
    localStorage.removeItem('lsDescFull');
}
export function setLocDatIniStorage(value: string) {
    localStorage.setItem('LocDatIni', value);
}
export function getLocDatIniStorage() {
    const result = localStorage.getItem('LocDatIni');
    if (!result) return null;
    return result;
}
export function cleanLocDatIniStorage() {
    localStorage.removeItem('LocDatIni');
}
export function setLocDatFinStorage(value: string) {
    localStorage.setItem('LocDatFin', value);
}
export function getLocDatFinStorage() {
    const result = localStorage.getItem('LocDatFin');
    if (!result) return null;
    return result;
}
export function cleanLocDatFinStorage() {
    localStorage.removeItem('LocDatFin');
}
export function setlocalTimerStorage(value: string) {
    localStorage.setItem('localTimer', value);
}
export function getlocalTimerStorage() {
    const result = localStorage.getItem('localTimer');
    if (!result) return null;
    return result;
}
export function cleanlocalTimerStorage() {
    localStorage.removeItem('localTimer');
}
export function setlangStorage(value: string) {
    localStorage.setItem('lang', value);
}
export function getlangStorage() {
    const result = localStorage.getItem('lang');
    if (!result) return null;
    return result;
}
export function cleanlangStorage() {
    localStorage.removeItem('lang');
}
export function setpopErrorStorage(value: string) {
    localStorage.setItem('popError', value);
}
export function getpopErrorStorage() {
    const result = localStorage.getItem('popError');
    if (!result) return null;
    return result;
}
export function cleanpopErrorStorage() {
    localStorage.removeItem('popError');
}

export async function handleUserLogOut() {

    let token = getAccessTokenLocalStorage();
    let user = getUserPreferenceLocalStorage();
    cleanTokenLocalStorage();
    cleanUserPreferenceLocalStorage();

    if (user == null) {
        return;
    }

    const data = {
        UserAutoScroll: user.autoUpdate,
        Data: user.archivedReport,
        HorarioIni: user.archivedReport?.date,
        Horario: user.archivedReport?.end,
        Language: { Id: user.languageID },
        Periodicidade: { Id: user.mergedRows?.frequencyID },
        Praca: { Id: user.groupID, Desc: user.groupLabel, Abrev: user.groupShortLabel },
        Target: { Id: user.classID },
        Indice: user.variableComboID,
        Ordenacao: user.mergedRows?.mergeFunctionID,
        Country: { CountryID: user.countryID },
        PracaImagem: {},
        ChangeAutoUpdate: false,
        TipoBase: user.baseID,
        LoginTipo: "LOGOUT"
    };
    await Desconecta(token, data);
}

function ValidUserIsAuthenticated(): boolean {
    let userData = getUserAuthLocalStorage();
    let token = getAccessTokenLocalStorage();
    if (ValidUserAuthLocalStorage(userData) && ValidAccessTokenLocalStorageValue(token)) {
        return true;
    }
    return false;
}

function ValidAccessTokenLocalStorageValue(token): boolean {
    return (token ?? false) && token !== "";
}

function ValidUserAuthLocalStorage(userData): boolean {
    return userData?.token ?? false;
}

export function ValidAccessTokenLocalStorage(): boolean {
    let token = getAccessTokenLocalStorage();
    return ValidAccessTokenLocalStorageValue(token);
}

export function handleUserLogOutErro(err, userAuthauthenticated: boolean, setUserAuthenticated, setUserMenssageApi) {
    let userLogged: boolean = ValidUserIsAuthenticated();
    if (Number(err?.response?.status) === 401 && userAuthauthenticated === true && userLogged || err?.response?.data.CodErro == 99 || err?.response?.data.error === "consult_user_not_found_square") {
        handleUserLogOut();
        setUserAuthenticated(false);
        setUserMenssageApi(err?.response?.data?.error_description || err?.response?.data?.Message || err?.response?.data?.MsgErro);
    }

}
export function handleMsgError(err: any, setIsErro: boolean, setMsgError, setError): void {
    setMsgError(err?.response?.data?.Message);
    setError(setIsErro);

}
export function setChannelOrderLocalStorage(order: ChannelDataOrder) {
    localStorage.setItem('ChannelDataOrder', order.toString());
}
export function getChannelOrderLocalStorage() {
    const result = localStorage.getItem('ChannelDataOrder');
    let resultType = ChannelDataOrder.ByLabel;
    if (!result) return resultType;

    if (Number(result) === 0)
        resultType = ChannelDataOrder.BySeq;

    return resultType;

}
export function cleanChannelDOrderStorage() {
    localStorage.removeItem('ChannelDataOrder');
}

export function handleLanguageFormat(language: string) {
    let languageParts = language.split('-');
    let result: string = '';
    if (languageParts.length === 2)
        result = languageParts[0].toLowerCase() + '-' + languageParts[1].toUpperCase();
    return result;
}

export function seti18nextLngLocalStorage(language: string) {
    localStorage.setItem('i18nextLng', language);
}
export function geti18nextLngLocalStorage() {
    const token = localStorage.getItem('i18nextLng');
    if (!token) return null;
    return token;
}
export function cleani18nextLngLocalStorage() {
    localStorage.removeItem('i18nextLng');
}
export function handleStartupLanguage(i18n, i18next, showSideicon) {
    const languageStorage = geti18nextLngLocalStorage();
    if (i18next.language !== languageStorage) {
        changeLanguage(languageStorage, i18n, null);
    }
    if (languageStorage) showSideicon(languageStorage.toLowerCase());
}
export function setDateTimeAudienceStorage(value: IDateTimeAudienceCountry) {
    localStorage.setItem('DateTimeAudience', JSON.stringify(value));
}
export function getDateTimeAudienceStorage() {
    const json = localStorage.getItem('DateTimeAudience');
    if (!json) return null;
    const result: IDateTimeAudienceCountry = JSON.parse(json);
    return result;
}
export function cleanDateTimeAudienceStorage() {
    localStorage.removeItem('DateTimeAudience');
}
export function getChartDivisionsExp(array, width) {
    if (array == null)
        return [];
    let chartDivisions = array.map((cell, cellIndex) => {
        let percentX = (cellIndex) / (array.length - 1);

        let scaledPercentX = Math.sqrt(1 - percentX); //exponential

        let x = width - scaledPercentX * width;
        return Math.round(x);
    });
    return chartDivisions;
}

export function setSelectTypeGridStorage(value: number) {
    localStorage.setItem('selectTypeGrid', value.toString());
    
    const userPreference = getUserPreferenceLocalStorage();
    if (userPreference) {
        userPreference.selectTypeGrid = value;
        localStorage.setItem('userPreference', JSON.stringify(userPreference));
    }
}

export function getSelectTypeGridStorage(): number {
    const userPreference = getUserPreferenceLocalStorage();
    if (userPreference?.selectTypeGrid !== undefined) {
        return userPreference.selectTypeGrid;
    }
    
    const result = localStorage.getItem('selectTypeGrid');
    if (!result) return 0;
    return parseInt(result);
}

export function cleanSelectTypeGridStorage() {
    localStorage.removeItem('selectTypeGrid');
    
    const userPreference = getUserPreferenceLocalStorage();
    if (userPreference) {
        delete userPreference.selectTypeGrid;
        localStorage.setItem('userPreference', JSON.stringify(userPreference));
    }
}